import React from 'react'
import { useMemo } from 'sb-hooks'
import cx from 'classnames'
import { formatPrice } from 'common/helpers'

import s from './UpchargePrice.scss'


type UpchargePriceProps = {
  className?: string
  price: number
  size?: 'sm' | 'md' | 'lg'
  dataTestId?: string
}

const UpchargePrice: React.FunctionComponent<UpchargePriceProps> = (props) => {
  const { className, price = 0, size = 'md', dataTestId = 'upchargePrice' } = props

  const rootClassName = cx(s.container, className, {
    [s[size]]: Boolean(s[size]),
  })

  const upchargePrice = useMemo(() => (
    `+${formatPrice(price, true, true, 0)}`
  ), [ price ])

  return (
    <span className={rootClassName} data-testid={dataTestId}>
      {upchargePrice}
    </span>
  )
}


export default React.memo(UpchargePrice)
